// Cross-component registry so only one wavesurfer-based playback plays at a time
// (shared between the user's own "Me" recording and the "Others" sample responses,
// as well as any similar playback UI that opts in).

let active = null;

const safePause = (ws) => {
  if (!ws) return;
  try {
    ws.pause();
  } catch (e) {
    // instance may already be destroyed — ignore
  }
};

// Call when a playback starts. Pauses any other currently-active instance.
export const registerActivePlayback = (ws) => {
  if (active && active !== ws) {
    safePause(active);
  }
  active = ws;
};

// Call on pause / finish / unmount. Only clears if this instance still owns the slot.
export const unregisterActivePlayback = (ws) => {
  if (active === ws) {
    active = null;
  }
};

// Stop whatever is currently playing (used by Next / Submit / See Result buttons).
export const stopActivePlayback = () => {
  safePause(active);
  active = null;
};
